import { createSelector } from "@reduxjs/toolkit"
import { useAppSelector } from "./hooks"
import { Attributes } from "src/features/shared-module/models"
import { appConstants } from "src/features/shared-module/constants"

const selectRouteDetailById = createSelector(
  [
    (state) => state.dashboard.orderRouteSummaryMap,
    (_, routeSummaryId) => routeSummaryId,
  ],
  (orderRouteSummaryMap, routeSummaryId) => {
    if (!routeSummaryId || !orderRouteSummaryMap) return null

    const routeSummary = orderRouteSummaryMap[routeSummaryId].routeDetail
    if (!routeSummary || !routeSummary.raw) return null

    const rawData = routeSummary.raw

    if (
      !rawData.routes ||
      !rawData.routes.features ||
      !rawData.routes.features[0]
    ) {
      return null
    }

    return rawData.routes.features[0].attributes
  },
)

export const useRouteDetail = (routeSummaryId: number | null): Attributes => {
  return useAppSelector((state) => selectRouteDetailById(state, routeSummaryId))
}

export const useEmployeeColor = (haulerEmployeeId: number | null): string => {
  return useAppSelector((state) =>
    haulerEmployeeId
      ? state.dashboard.employeeList.find(
          (haulerEmployee) => haulerEmployee.id === haulerEmployeeId,
        )?.color || appConstants.defaultRouteColor
      : appConstants.defaultRouteColor,
  )
}
